import { render, staticRenderFns } from "./signup.html?vue&type=template&id=3b97e61d&scoped=true&external"
import script from "./signup.js?vue&type=script&lang=js&external"
export * from "./signup.js?vue&type=script&lang=js&external"
import style0 from "./signup.scss?vue&type=style&index=0&id=3b97e61d&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b97e61d",
  null
  
)

export default component.exports